module.exports = __webpack_public_path__ + "static/img/first_banner.a1d24f56.jpg";